export enum EnvironmentStage {
    Local = 'local',
    Development = 'development',
    Production = 'production',
    Preproduction = 'preproduction',
    Test = 'test',
}

const environmentStageShortNames: { [key: string]: EnvironmentStage; } = {
    "local": EnvironmentStage.Local,
    "dev": EnvironmentStage.Development,
    "prod": EnvironmentStage.Production,
    "preprod": EnvironmentStage.Preproduction,
    "test": EnvironmentStage.Test,
} as const;

export const getRuntimeEnvironmentStage = (): EnvironmentStage | null => {
    try {
        // This condition taken from isLocalEnvironment, we check if the hostname includes localhost
        if ((window?.location?.hostname ?? "").includes("localhost")) {
            return EnvironmentStage.Local;
        }

        // This condition taken from isTestEnvironment, we get the environment from the process object
        if (process?.env?.NODE_ENV === "test") {
            return EnvironmentStage.Test;
        }

        // For all other environments, we get the environment from the window object.
        let stage = (window?.__RUNTIME_ENV__?.ENVIRONMENT ?? "").toLowerCase();
        if (!stage) {
            return null;
        }

        for (const key in environmentStageShortNames) {
            if (stage.startsWith(key)) {
                return environmentStageShortNames[key];
            }
        }
    } catch (e) {
        console.error("Error getting runtime environment stage", e);
    }

    return null;
};